<template>
  <div id='friendCircle' class='leaveStu'>

    <Scroll :on-reach-bottom="handleReachBottom" :distance-to-edge='10' :height='contentHeight'>
      <Row>
        <Breadcrumb>
          <BreadcrumbItem to="">APP管理</BreadcrumbItem>
          <BreadcrumbItem to="">吴江圈审核</BreadcrumbItem>
        </Breadcrumb>
      </Row>
      <Row xs="20" sm="16" md="12" lg="8">
        <Col span='5'>
        <Select v-model="status">
          <Option value="-1" key="-1">全部作品</Option>
          <Option value="0" key="0">待审核</Option>
          <Option value="3" key="3">被举报</Option>
          <Option value="1" key="1">审核通过</Option>
          <Option value="2" key="2">审核未通过</Option>
        </Select>
        </Col>
        <Col span='1'>
        <Button type="info" @click='searchData'>查询</Button>
        </Col>
      </Row>
      <!-- <div class='conheadRight'>
					<i-button type="error" @click.native='newFriend' class='addCircle'>发布班级圈</i-button>
				</div> -->

      <!-- <div class='conhead'>


					<i-button type="error" @click.native='newFriend' class='addCircle'>发布班级圈</i-button>

			</div> -->
      <ul class='friendcircle'>
        <li v-for="(item, father_index) in happens" :key="item.id" :id="father_index" class="list">
          <img :src="item.pic" class="avatars" v-if="item.pic != ''" />
          <img src="/dist/img/student_default3x.png" class="avatars" v-else />
          <Button type="info" size='small' @click='dealwith(item.guid, father_index)' class='dealwith'
            v-if='item.status == 0 || item.status == 2'>通过</Button>
          <Button type="warning" size='small' @click='dealrefuse(item.guid, father_index)'
            v-if='item.status == 0 || item.status == 1' class='dealwith2'>拒绝</Button>
          <div class="content">
            <div class='nickName'>{{ item.name }}</div>
            <div class="info">{{ item.msgContent }}</div>
            <!-- <div class="pics" v-if="item.pics!=''">
							<img v-for="pic in item.pics" :src="pic | picfilter" />
						</div> -->
            <viewer :images="item.pics" class="pics">
              <img v-for="pic in item.pics" :src="pic | picfilter" :data-source="pic | picBigfilter" />

            </viewer>

            <!-- <div class="ratingList" :data-show="item.show" v-if="item.show!='show'">
							<div class="sanjiao"></div>
							<div class="good" v-if="item.likeList!=''">
								<img src="/dist/img/Like3x.png" />
								<span v-for="likeItem in item.likeList" :key="likeItem.guid">{{likeItem.name}}</span>
							</div>
							<div class="rating_item replayComment" v-for="(rating,index) in item.commentList" v-if="item.commentList!=''" >
								<div class='commentItems' v-if="rating.replayname==''" :data-name="rating.name" :data-guid="item.guid"
								 :data-smallguid="rating.guid" :data-userid="rating.userid" :data-index="father_index" :data-self="item.isSelf"
								 :data-smallindex="index" style="overflow:hidden;">
									<span class="rating_name" style="" @click.prevent='replyTo(rating.userid,rating.name,item.guid,rating.guid,father_index,index)'>{{rating.name}}：</span>
									<div class='english' style="display:inline;overflow:hidden;">
										<span style="">{{rating.comment}}</span>
									</div>
								</div>
								<div :data-bigindex="father_index" :data-smallindex="index" catchTap="removeOtherRating" :data-userid="rating.userid"
								 :data-guid="rating.guid" v-else style="overflow:hidden;">
									<span class="rating_name" style="" @click.prevent='replyTo(rating.userid,rating.name,item.guid,rating.guid,father_index,index,0)'>{{rating.name}}</span>
									<span style=""> 回复</span>
									<span class="rating_name" style="" @click.prevent='replyTo(rating.replayid,rating.replayname,item.guid,rating.guid,father_index,index)'>{{rating.replayname}}</span>
									<span style=""> ：</span>
									<div class='english' style="display:inline;overflow:hidden;">

										<span style="">{{rating.comment}}</span>

									</div>
								</div>
							</div>
						</div> -->
          </div>
        </li>
      </ul>
      <h4 class='footline'></h4>
    </Scroll>
  </div>
</template>

<script>
export default {
  name: 'classcircle',
  data () {
    return {
      extradata: { type: 'class_cirlce' },
      happens: [],
      phoneType: 1,
      userid: '',
      show: -1,
      state: true,
      adminer: {},
      contentHeight: 120,
      pagenum: 1,
      replayToContent: '',
      replayToGuid: '',
      replayToId: '',
      replayToIndex: -1,
      newCircle: false,
      circleText: '',
      schoolData: [],
      initSchoolData: [],
      reloadTmep: -1,
      newGalleryData: '',
      classid: '',
      classname: '',
      uploadList: [],
      isup: false,
      status: '0'
    }
  },
  mounted () {
    //console.log(this.$layer)
    this.adminer = JSON.parse(localStorage.getItem('inchUserinfo'))
    this.contentHeight = document.documentElement.clientHeight - 50
    this.getCircle()
    var that = this

  },
  filters: {
    picfilter (val) {
      if (val.indexOf("@") > -1) {
        return val.split("@")[0]
      } else {
        return val
      }
    },
    picBigfilter (val) {
      if (val.indexOf("@") > -1) {
        return val.split("@")[1]
      } else {
        return val
      }
    }
  },
  methods: {
    searchData () {
      this.getCircle(1)
    },
    dealwith (guid, idx) {
      //console.log(guid)
      var param = {
        guid: guid,
        status: 1
      }
      var that = this
      this.axios.post('circleManager/updateAuditStatus', param).then(res => {
        //console.log(res)
        that.$Message.info(res.data)
        that.happens.splice(idx, 1)
      })
    },
    dealrefuse (guid, idx) {
      var param = {
        guid: guid,
        status: 2
      }
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认拒绝？</p>',
        onOk: () => {
          that.axios.post('circleManager/updateAuditStatus', param).then(res => {
            //console.log(res)
            that.$Message.info(res.data)
            that.happens.splice(idx, 1)
          })
        },
        onCancel: () => {

        }
      });

    },
    getPhotoList (val) {
      //console.log(val)
      this.newGalleryData = val
    },
    getSchoolTree (val) {
      //console.log(val)
      var classid = '', classname = '';
      val.map(function (val, index) {
        if (val['children'].length == 0) {
          classid += val['id'] + ','
          classname += val['name'] + ','
        }
      })
      this.classid = classid.substring(0, classid.length - 1)
      this.className = classname.substring(0, classname.length - 1)
    },
    postCircle () {
      var that = this
      if (this.classid == '') {
        this.$Message.warning('请选择班级')
        return false
      }
      //console.log(this.newGalleryData)
      var pics = ''
      if (this.newGalleryData.length > 0) {
        var filelist = this.newGalleryData
        var pic = ''
        filelist.map(function (val, index) {
          pic += val['response']['url'] + "?" + val['name'] + ','
        })
        pics = pic.substring(0, pic.length - 1)
        //console.log(pics)
      }
      if (pics == '' && this.circleText == '') {
        this.$Message.warning('请填写内容或者图片')
        return false
      }
      var param = {

      }
      this.isup = true
      this.axios.post('classcircle/save', param).then(res => {
        that.isup = false
        that.getCircle(1)
        that.newCircle = false
      })

    },
    newFriend () {
      this.reloadTmep = Math.random()
      this.schoolData = JSON.parse(JSON.stringify(this.initSchoolData))
      this.newCircle = true
    },
    handleReachBottom () {
      //console.log(1111)
      var that = this
      return new Promise(resolve => {
        that.getCircle()
        resolve()
      })
    },
    getCircle (pageNum) {
      var that = this
      var pageNum = pageNum || this.pagenum
      var param = {
        pageno: pageNum,
        length: 10,
        userid: that.adminer.guid,
        status: this.status,
      }

      this.axios.get('circleManager/getQueryList', {
        params: param
      }).then(res => {
        //console.log(res.data)
        if (res.data.length > 0) {
          for (var i = 0; i < res.data.length; i++) {
            var _phoneType = that.phoneType

            if (_phoneType == 1) {
              var _d = res.data[i]["addtime"].replace(/\-/g, "/")
              if (_d.indexOf(".") > -1) {
                _d = _d.replace(".0", '')
              }



              res.data[i]["addtime"] = that.timestampFormat(_d)
            } else {
              var _d = res.data[i]["addtime"]
              if (_d.indexOf(".") > -1) {
                _d = _d.replace(".0", '')
              }
              res.data[i]["addtime"] = that.timestampFormat(_d)
            }
            //  var date = new Date(res.data[i]["addtime"]);
            //  var time1 = date.getTime();
            //  res.data[i]["addtime"] = that.timestampFormat(time1)

            res.data[i]["msgContent"] = decodeURIComponent(decodeURI(res.data[i]["msgContent"]))
            if (res.data[i]["commentList"]) {
              for (var k = 0; k < res.data[i]["commentList"].length; k++) {
                res.data[i]["commentList"][k]["name"] = decodeURI(res.data[i]["commentList"][k]["name"])
                res.data[i]["commentList"][k]["replayname"] = decodeURI(res.data[i]["commentList"][k]["replayname"])
                res.data[i]["commentList"][k]["comment"] = (function (num) {


                  return decodeURIComponent(res.data[i]["commentList"][k]["comment"])
                  decodeURIComponent(res.data[i]["commentList"][k]["comment"]);

                })(i, k);
              }
            }

            // for (var l = 0; l < res.data[i]["likeList"].length; l++) {
            // 	if (res.data[i]["likeList"].length > 1) {
            // 		if (l != res.data[i]["likeList"].length - 1) {
            // 			res.data[i]["likeList"][l]["name"] += '，'
            // 		}
            // 	}
            // }
            // for (var m = 0; m < res.data[i]["likeList"].length; m++) {
            // 	res.data[i]["likeList"][m]["name"] = decodeURI(res.data[i]["likeList"][m]["name"])
            // 	res.data[i]["likeList"][m]["comment"] = decodeURI(res.data[i]["likeList"][m]["comment"])
            // 	if (res.data[i]["likeList"][m]["guid"] == that.adminer.guid) {
            // 		res.data[i]['liked'] = 1
            // 	}
            // }
            res.data[i]["name"] = decodeURI(res.data[i]["name"])
            ////console.log(res.data[i]["pics"])
            if (res.data[i]["pics"] && res.data[i]["pics"] != "") {
              if (res.data[i]["pics"].indexOf("?") > -1) {
                var _rpic = res.data[i]["pics"].split(',')
                _rpic.map(function (val, index) {
                  val = val.split("?")[0]
                })

                res.data[i]["pics"] = _rpic
              } else {
                res.data[i]["pics"] = res.data[i]["pics"].split(',')
              }
              //res.data[i]["pics"] = res.data[i]["pics"].split(',')
            } else {
              res.data[i]["pics"] = []
            }
            if (res.data[i]["commentList"] == '' && res.data[i]["likeList"] == '') {
              res.data[i]["show"] = "show"
            }
            if (res.data[i]["userid"] == that.adminer.guid) {
              res.data[i]["isSelf"] = "self"
            }

          }
          var _data = ''
          if (pageNum != 1) {
            _data = that.happens.concat(res.data)
          } else {
            _data = res.data
          }
          ////console.log(_data)
          that.pagenum = pageNum + 1
          that.happens = _data
          that.$forceUpdate()
        } else {

          if (pageNum == 1) {
            that.happens = []
            that.$forceUpdate()
          }
          that.$Message.warning('数据加载完毕')
        }
      })
    },
    webShowRat (index) {
      ////console.log(index,'show')
      this.show = this.show == index ? -1 : index
    },
    removeItem (guid, index) {
      var that = this
      this.$Modal.confirm({
        title: '是否确认删除',
        onOk: function () {
          that.axios.delete("classcircle/delete?id=" + guid, {
            id: guid
          }).then(res => {
            var happens = that.happens
            happens.splice(index, 1)
            that.happens = happens

          })

        }
      })
    },
    goods (guid, islike, fa_index) {
      ////console.log(guid,islike,fa_index)

      var that = this
      if (islike == 0) {
        var param = {
          guid: guid,
          headpic: this.adminer.face,
          name: this.adminer.name,
          userid: this.adminer.guid,
        }
        this.axios.post('classcircle/addLike', param).then(res => {
          ////console.log(res)
          that.show = -1
          that.addData(0, fa_index, {
            name: this.adminer.name,
            guid: guid
          })
        })
      } else {

        this.axios.delete('classcircle/delLike?guid=' + guid + '&userid=' + this.adminer.guid, param).then(res => {

          that.show = -1
          that.addData(1, fa_index, {
            name: this.adminer.name,
            guid: guid
          })
        })
      }
    },
    addData (state, _index, good) {
      var _data = this.happens,
        that = this;
      if (state == 0) {
        //  if dislike
        var _len = _data[_index]["likeList"].length;
        if (_len == 0) {
          _data[_index]["likeList"].push(good)
          _data[_index]["liked"] = 1
          _data[_index]["show"] = ''

          that.happens = _data

          that.state = true

        } else {
          good.name = '，' + good.name
          _data[_index]["likeList"].push(good)
          _data[_index]["liked"] = 1
          that.happens = _data

          that.state = true
        }

      } else {
        //  //console.log(_data,_data[_index]["likeList"].length, "likelist.length11111")
        _data[_index]["liked"] = 0
        var _len = _data[_index]["likeList"].length;

        for (var k = 0; k < _data[_index]["likeList"].length; k++) {
          if (_len > 1) {
            //console.log(_data, good.name, _data[_index]["likeList"][k]["name"], 'huangho ')
            if (good.name == _data[_index]["likeList"][k]["name"]) {
              //console.log(_data, good.name, 'huanghoudadaodong ')
              _data[_index]["likeList"].splice(k, 1)
              if (_data[_index]["likeList"] == '') {
                // _data[_index]["show"] = 'show'
              }
              //console.log(_data, good.name, 'huanghoudadaodong 111')
            } else {
              good.name = '，' + good.name
              //console.log(_data, good.name, _data[_index]["likeList"][k]["name"], 'huangho ')
              if (good.name == _data[_index]["likeList"][k]["name"]) {
                //console.log(_data, good.name, 'huanghoudadaoxi ')
                _data[_index]["likeList"].splice(k, 1)
                if (_data[_index]["likeList"] == '') {
                  // _data[_index]["show"] = 'show'
                }
                //console.log(_data, good.name, 'huanghoudadaoxi 111')
              }
            }


          } else {
            if (good.name == _data[_index]["likeList"][0]["name"]) {
              _data[_index]["likeList"].splice(0, 1)
              if (_data[_index]["likeList"] == '') {
                if (_data[_index]["commentList"] == '') {
                  _data[_index]["show"] = 'show'
                }
              }
            }
          }
        }
        that.happens = _data

        that.state = true



      }
    },
    rating (guid, faIndex) {
      var that = this
      that.replayToGuid = guid
      that.replayToIndex = faIndex
      that.show = -1
      this.$Modal.confirm({
        render: (h) => {
          return h('Input', {
            props: {
              value: this.value,
              autofocus: true,
              placeholder: '发表你的见解...'
            },
            on: {
              input: (val) => {
                that.replayToContent = val;
              }
            }
          })
        },
        onOk: function () {
          that.postRating()
        }
      })
    },
    replyTo (userid, name, guid, itemGuid, faIndex, index, isreplay) {
      //console.log(userid,name,guid,itemGuid,faIndex,index)
      var that = this
      that.replayToIndex = faIndex
      that.replayToGuid = guid
      if (userid == this.adminer.guid) {
        var postUrl = ''
        if (isreplay == 0) {
          postUrl = 'classcircle/delCommentReplay?id=' + itemGuid
        } else {
          postUrl = 'classcircle/delComment?id=' + itemGuid
        }
        this.$Modal.confirm({
          title: '是否确认删除',
          onOk: function () {
            that.axios.delete(postUrl, {
              id: guid
            }).then(res => {
              var happens = that.happens

              happens[faIndex]["commentList"].splice(index, 1)
              that.happens = happens

            })

          }
        })
      } else {
        this.$Modal.confirm({
          render: (h) => {
            return h('Input', {
              props: {
                value: this.value,
                autofocus: true,
                placeholder: '回复' + name
              },
              on: {
                input: (val) => {
                  that.replayToContent = val
                }
              }
            })
          },
          onOk: function () {
            that.postRating(userid, name, itemGuid)
          }
        })
      }
    },
    postRating (userid, name, itemGuid) {
      var that = this;
      if (that.replayToContent == '' || that.replayToContent == undefined) {

        return false
      }
      var param = {}
      if (!userid) {
        param = {
          comment: that.replayToContent,
          name: that.adminer.name,
          pguid: that.replayToGuid,
          headpic: that.adminer.face,
          userid: that.adminer.guid,
        }
        //console.log(param, "param")
        this.axios.post('classcircle/addComment', param).then(res => {

          that.ratingSuccess(0, name, userid, res.guid, that.adminer.guid)
        })



      } else {
        param = {
          comment: that.replayToContent,
          name: that.adminer.name,
          pguid: that.replayToGuid,
          replayid: userid, //你要回复的这个人的id
          replayname: name, //你要回复的这个人的姓名
          userid: that.adminer.guid,
          headpic: that.adminer.face
        }
        //console.log(param, "reply to param")
        this.axios.post('classcircle/addComment', param).then(res => {
          //console.log(res)
          that.ratingSuccess(1, name, userid, res.guid, that.adminer.guid)
        })

      }



    },
    ratingSuccess (replayOther, replayname, replayid, itemGuid, userid) {

      var _data = this.happens,
        that = this,
        _index = this.replayToIndex;



      if (replayOther == 1) {
        _data[_index]['commentList'].push(
          {
            name: that.adminer.name,
            comment: that.replayToContent,
            replayname: replayname,
            replayid: replayid,
            guid: itemGuid,
            userid: userid,
          })


        that.happens = _data
      } else {
        if (_data[_index]['commentList'].length == 0) {
          if (_data[_index]['likeList'].length == 0) {
            _data[_index]["show"] = ''
            _data[_index]['commentList'].push({

              name: that.adminer.name,
              comment: that.replayToContent,
              replayname: '',
              replayid: '',
              guid: itemGuid,
              userid: userid,
            })
          } else {
            _data[_index]['commentList'].push({
              name: that.adminer.name,
              comment: that.replayToContent,
              replayname: '',
              replayid: '',
              guid: itemGuid,
              userid: userid,
            })

          }
        } else {
          _data[_index]['commentList'].push({
            name: that.adminer.name,
            comment: that.replayToContent,
            replayname: '',
            replayid: '',
            guid: itemGuid,
            userid: userid,
          })
        }
        //console.log(_data, 2)

        that.happens = _data

      }
    },
    timestampFormat (timestamp) {
      var that = this

      function zeroize (num) {
        return (String(num).length == 1 ? '0' : '') + num;
      }

      var curTimestamp = parseInt(new Date().getTime()); //当前时间戳

      if (that._phoneType == 1) {
        if (typeof (timestamp) == 'number') {
        } else {
          timestamp = timestamp.replace(/\-/g, "\/")
        }
      }
      var curDate = new Date(curTimestamp); // 当前时间日期对象
      var tmDate = new Date(timestamp) // 参数时间戳转换成的日期对象


      var timestampDiff = curTimestamp - tmDate; // 参数时间戳与当前时间戳相差秒数



      var Y = tmDate.getFullYear(),
        m = tmDate.getMonth() + 1,
        d = tmDate.getDate();
      var H = tmDate.getHours(),
        i = tmDate.getMinutes(),
        s = tmDate.getSeconds();

      var newDate = new Date((curTimestamp - 86400000)); // 参数中的时间戳加一天转换成的日期对象
      if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
        return '昨天 ' + zeroize(H) + ':' + zeroize(i);
      } else if (timestampDiff < 3600 * 24 * 1000) {
        return zeroize(H) + ':' + zeroize(i)
      } else if (timestampDiff < 3600 * 24 * 7 * 1000) {
        return that.oneDay(Y, m, d) + ' ' + zeroize(H) + ':' + zeroize(i)
      } else {
        var newDate = new Date((curTimestamp - 86400000)); // 参数中的时间戳加一天转换成的日期对象
        if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
          return '昨天' + zeroize(H) + ':' + zeroize(i);
        } else if (curDate.getFullYear() == Y) {
          return zeroize(m) + '-' + zeroize(d) + ' ' + zeroize(H) + ':' + zeroize(i);
        } else {
          return Y + '-' + zeroize(m) + '-' + zeroize(d) + ' ' + zeroize(H) + ':' + zeroize(i);
        }
      }
    },
    oneDay (y, m, d) {
      var myDate = new Date();
      myDate.setFullYear(y, m - 1, d);
      var week = myDate.getDay()
      switch (week) {
        case 0:
          return '周日';
        case 1:
          return '周一';
        case 2:
          return '周二';
        case 3:
          return '周三';
        case 4:
          return '周四';
        case 5:
          return '周五';
        case 6:
          return '周六';
      }
    },
  }
}
</script>

<style scoped>
#friendCircle {
  position: relative;
  z-index: 10;
  padding-bottom: 50px;
}

#friendCircle .addCircle {
  margin-right: 10px;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 15px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

li {
  list-style: none;
}

#friendCircle .list {
  display: flex;
  justify-content: flex-start;
  min-height: 130px;
}

#friendCircle .list .content {
  flex: 1;
}

#friendCircle .avatars {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  margin-right: 20px;
  position: relative;
  top: 2px
}

#friendCircle .nickName {
  color: #576b95;
  font-size: 14px;
  /* font-weight:bold; */
}

#friendCircle .info {
  margin-top: 2px;
  color: #515a6e;
  font-size: 14px;
  margin-bottom: 4px;
  font-weight: bold;
}

#friendCircle .pics img {
  width: 80px;
  height: 80px;
  float: left;
  margin-right: 8px;
  margin-top: 10px;
  border-radius: 4px;
}

#friendCircle .bottom {
  font-size: 14px;
  color: #999;
  margin-top: 5px;
  position: relative;
  height: 30px;
  line-height: 30px;
}

#friendCircle .bottom .time {
  font-size: 12px;
}

#friendCircle .bottom .editor {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0px;
  bottom: 4px;
  cursor: pointer;
}

#friendCircle .pics {
  overflow: hidden;
}

#friendCircle .list {
  overflow: hidden;
  padding: 20px 0px;
  padding-bottom: 15px;
  position: relative;
  padding-right: 20px;
}

#friendCircle .list+.list {
  border-top: 1px solid #f5f5f5;
}

#friendCircle .good img {
  width: 18px;
  height: 18px;
  float: left;
  position: relative;
  top: 1px;
  margin-right: 2px;
}

#friendCircle .good {
  overflow: hidden;
  color: #576b95;
  padding: 0px 5px 3px 12px
}

/* .good+.rating_item{
	    border-top:1px solid #ddd;
	} */

#friendCircle .good text {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #576b95;
  margin-left: 5px;
  float: left;
}

#friendCircle .ratingList {
  background: #f8f8f8;
  margin-top: 10px;
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  z-index: 20;
}

#friendCircle .rating_item {
  padding: 3px 12px;
  font-size: 14px;
  color: #222;

  padding-bottom: 0px;
}

#friendCircle .sanjiao {
  background: #f8f8f8;
  display: inline-block;

  width: 10px;
  height: 10px;
  position: absolute;
  left: 15px;
  top: -4px;
  transform: rotate(45deg);
  z-index: 10;
}

#friendCircle .rating_name {
  color: #3b5384;
  cursor: pointer;
}

#friendCircle .hideState {
  height: 35px;
  background: #666;
  width: 180px;
  line-height: 35px;
  position: absolute;
  right: 35px;
  bottom: -2px;
  overflow: hidden;
  transition: all 500ms ease;
  border-radius: 5px;
}

#friendCircle .hideState>div {
  width: 50%;
  float: left;
  text-align: center;
  height: 35px;
  line-height: 35px;
  padding: 0px 8px;
  font-size: 14px;
  cursor: pointer;
}

#friendCircle .hideState div span {
  display: inline-block;
  height: 35px;
  line-height: 35px;
  color: #fff;
}

#friendCircle .hideState img {
  width: 20px;
  height: 20px;
  position: relative;
  top: 6px;
  margin-right: 5px;
}

#friendCircle #friendCircle {
  padding-right: 0px !important;
  position: relative;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.pics img {
  cursor: pointer;
}

.removeItem {
  color: #5e6a8f;
  margin-left: 10px;
  font-size: 10px;
  cursor: pointer;
  position: relative;
  top: -0.5px;
}

.conhead {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  position: relative;
  top: -10px;
  margin-top: 20px;
  padding-right: 10px;
}

.conheadleft {
  min-width: 350px;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  ;
}

.conheadleft h4 {
  margin: 15px 0px 4px;
}

.conheadleft p {
  color: #bbb;
  font-size: 12px;
}

.conheadleft img {
  width: 120px;
  height: 70px;
  margin-right: 5px;
  margin-top: 6px;
}

.conheadRight {
  line-height: 70px;

}

.footline {
  text-align: center;
}

.dealwith {
  position: absolute;
  top: 70px;
  left: 0px;
}

.dealwith2 {
  position: absolute;
  top: 95px;
  left: 0px;
}
</style>
